import Card from "../../components/UI/Card";
import {checkPermission} from "../../util/auth";

const AccountBalanceSummary = ({commissionInfo, openWithdrawRequestModal}) => {
  return(
    <Card title={'Account Summary'}>
      { commissionInfo && (
          <>
            <table className="table table_bordered_none transaction_page_table">
              <tbody>
              <tr>
                <td>Total</td>
                <td className="text_right color_grey">${commissionInfo.total_commission?.toFixed(2)}</td>
              </tr>
              <tr>
                <td>Total Withdraw</td>
                <td className="text_right color_grey">-${commissionInfo.total_withdraw?.toFixed(2)}</td>
              </tr>
              <tr>
                <td>Withdraw Pending</td>
                <td className="text_right color_grey">-${commissionInfo.pending_withdraw?.toFixed(2)}</td>
              </tr>
              <tr>
                <td>Available balance</td>
                <td className="text_right color_grey">${commissionInfo.withdrawable_amount?.toFixed(2)}</td>
              </tr>

              </tbody>
            </table>
            <div className="d_flex_end pt_10">
              {checkPermission(['WITHDRAW_REQUEST']) &&
              <button className="btn btn_md btn_black has_border_radius width_full"
                      onClick={openWithdrawRequestModal}>Withdraw Request</button>
              }
            </div>
          </>
      )}
    </Card>
  );
}

export default AccountBalanceSummary